function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M10.7841101 17.7547945c-.33288399 0-.60273976-.2698557-.60273976-.6027397v-4.9213699H7.94520596l.02109589 4.9183562c.00339287.1648105-.06086397.3238189-.17780822.44-.11325371.1139297-.26730164.1779355-.42794521.1778082H3.02383609c-.33288396 0-.60273972-.2698557-.60273972-.6027397l-.04520548-7.92904109-1.5369863-1.22958905C.69852918 7.8910126.617073 7.71948574.617073 7.53835618c0-.18112957.08145618-.35265643.22183159-.46712329L8.69260322.4410959c.22401208-.1878252.55050846-.1878252.77452054 0L17.3027402 7.0712329c.1359009.11843629.2139252.28986998.2139726.47013699-.0070862.17595178-.0907645.34000519-.2290411.44904109l-1.5369863 1.23260274-.0421918 7.93205479c0 .332884-.2698557.6027397-.6027397.6027397l-4.3216438-.0030137z",
  fill: "#333647"
}), React.createElement("path", {
  stroke: "#333647",
  strokeWidth: .5,
  fill: "#FFF",
  d: "M15.1057539 17.1520548l.0452055-8.22136986 1.7630137-1.41041096L9.06931554.90520549 1.21561691 7.52328768l1.76 1.41342466.04821918 8.21534246h4.33671233l-.02410959-5.5241096h3.44767127v5.5241096z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/home.7b44254a.svg";
export { SvgComponent as ReactComponent };